export const lines: any = {
  "mmrcl": {
    "Line 1": {
      "name": "Blue Line",
      "color": "#1e90ff",
      "stations": [
        {
          "id": 0,
          "code": "ACA",
          "name": "Acharya Atre Chowk",
          "name_hi": "आचार्य अत्रे चौक",
          "name_mr": "आचार्य अत्रे चौक",
          "is_start": true,
          "is_end": false
        },
        {
          "id": 1,
          "code": "WOR",
          "name": "Worli",
          "name_hi": "वरली",
          "name_mr": "वरळी",
          "is_start": false,
          "is_end": false
        },
        {
          "id": 2,
          "code": "SIDV",
          "name": "Siddhivinayak",
          "name_hi": "सिध्दिविनायक",
          "name_mr": "सिध्दिविनायक",
          "is_start": false,
          "is_end": false
        },
        {
          "id": 3,
          "code": "DDRM",
          "name": "Dadar Metro",
          "name_hi": "दादर मेट्रो",
          "name_mr": "दादर मेट्रो",
          "is_start": false,
          "is_end": false
        },
        {
          "id": 4,
          "code": "SDIT",
          "name": "Shitala Devi Mandir",
          "name_hi": "शितलादेवी मंदिर",
          "name_mr": "शितलादेवी मंदिर",
          "is_start": false,
          "is_end": false
        },
        {
          "id": 5,
          "code": "DHAV",
          "name": "Dharavi",
          "name_hi": "धारावी",
          "name_mr": "धारावी",
          "is_start": false,
          "is_end": false
        },
        {
          "id": 6,
          "code": "BDRM",
          "name": "Bandra-Kurla Complex",
          "name_hi": "बांद्रा-कुर्ला कॉम्प्लेक्स",
          "name_mr": "वांद्रे-कुर्ला कॉम्प्लेक्स",
          "is_start": false,
          "is_end": false
        },
        {
          "id": 7,
          "code": "VIDN",
          "name": "Bandra Colony",
          "name_hi": "बांद्रा कॉलोनी",
          "name_mr": "वांद्रे कॉलनी",
          "is_start": false,
          "is_end": false
        },
        {
          "id": 8,
          "code": "STZM",
          "name": "Santacruz Metro",
          "name_hi": "सांताक्रूझ मेट्रो",
          "name_mr": "सांताक्रूझ मेट्रो",
          "is_start": false,
          "is_end": false
        },
        {
          "id": 9,
          "code": "CIAD",
          "name": "CSMI Airport-T1",
          "name_hi": "सी एस एम आई हवाई अड्डा - T1",
          "name_mr": "सी. एस. एम. आय विमानतळ - T1",
          "is_start": false,
          "is_end": false
        },
        {
          "id": 10,
          "code": "SHRR",
          "name": "Sahar Road",
          "name_hi": "सहार रोड",
          "name_mr": "सहार रोड",
          "is_start": false,
          "is_end": false
        },
        {
          "id": 11,
          "code": "CSIA",
          "name": "CSMI-Airport - T2",
          "name_hi": "सी. एस. एम. आई हवाई अड्डा - T2",
          "name_mr": "सी. एस. एम. आय विमानतळ - T2",
          "is_start": false,
          "is_end": false
        },
        {
          "id": 12,
          "code": "MNK",
          "name": "Marol Naka",
          "name_hi": "मरोल नाका",
          "name_mr": "मरोळ नाका",
          "is_start": false,
          "is_end": false
        },
        {
          "id": 13,
          "code": "MIDC",
          "name": "MIDC-Andheri",
          "name_hi": "एम.आई.डी.सी-अंधेरी",
          "name_mr": "एम.आय.डी.सी-अंधेरी",
          "is_start": false,
          "is_end": false
        },
        {
          "id": 14,
          "code": "SEPZ",
          "name": "SEEPZ",
          "name_hi": "सीप्ज़",
          "name_mr": "सीप्झ",
          "is_start": false,
          "is_end": false
        },
        {
          "id": 15,
          "code": "ARYJ",
          "name": "Aarey JVLR",
          "name_hi": "आरे जे.वी.एल.आर",
          "name_mr": "आरे जे.वी.एल.आर",
          "is_start": false,
          "is_end": true
        },
        {
          "id": 16,
          "code": "",
          "name": "",
          "name_hi": "",
          "name_mr": "",
          "hidden": true,
          "is_start": false,
          "is_end": false
        },
        {
          "id": 17,
          "code": "",
          "name": "",
          "name_hi": "",
          "name_mr": "",
          "hidden": true,
          "is_start": false,
          "is_end": false
        },
        {
          "id": 18,
          "code": "",
          "name": "",
          "name_hi": "",
          "name_mr": "",
          "hidden": true,
          "is_start": false,
          "is_end": false
        }
      ],
      "airports": [],
      "educational_institutes": [],
      "railway": [],
      "market": [],
      "hospital": [],
      "bus": []
    }
  },
}